import packageJson from '../package.json';
import versionJson from 'rkVersionJson';

declare const require: (id: string) => unknown;

type PackageJsonLike = Partial<{
  name: string;
  dependencies: Record<string, string>;
}>;

const pkg = packageJson as unknown as PackageJsonLike;

type SdkVersions = Partial<{
  upime: string;
  whiteboard: string;
  recorder: string;
}>;

type AnyPackageJson = Partial<{
  dependencies: Record<string, string>;
  devDependencies: Record<string, string>;
  peerDependencies: Record<string, string>;
}>;

function getUpimeFromWhiteboard(): string | undefined {
  try {
    const wbPkg = require('@plaso-infi/whiteboard-sdk/package.json') as AnyPackageJson;
    return (
      wbPkg.dependencies?.['@plasosdk/upime-sdk'] ??
      wbPkg.devDependencies?.['@plasosdk/upime-sdk'] ??
      wbPkg.peerDependencies?.['@plasosdk/upime-sdk']
    );
  } catch {
    return undefined;
  }
}

export interface RkVersionsEntry {
  project: string;
  version: string;
  sdk: SdkVersions;
}

declare global {
  interface Window {
    __RK_VERSIONS__?: RkVersionsEntry;
  }
}

export function initRkVersions(): void {
  try {
    const upime = pkg.dependencies?.['@plasosdk/upime-sdk'] ?? getUpimeFromWhiteboard();

    const sdk: SdkVersions = {
      upime,
      whiteboard: pkg.dependencies?.['@plaso-infi/whiteboard-sdk'],
      recorder: pkg.dependencies?.['@plasosdk/upime-sdk-recorder'],
    };

    const entry: RkVersionsEntry = {
      project: pkg.name ?? 'unknown',
      version: versionJson.version,
      sdk,
    };

    window.__RK_VERSIONS__ ??= entry;
  } catch {
    // ignore
  }
}

